module.exports = __webpack_public_path__ + "static/slider-1-scratch-db7d035e265e97031930f8884a2b2d9f.png";